export default __webpack_public_path__ + "static/roxane-kroon-0f372cfe0427086bfd272e0808440e2d.png";